import { VTabs, VTab, VTabsItems, VTabItem, VCard } from 'vuetify/lib'
import ZNcontain from './ZNcontain'
import Table from '@/views/wage_title_mapping/new/Table.jsx'
import SxTable from './SxTable.jsx'
import {YGFL, FYZS, FYSX} from './constants'
const tabs_list = [
    {
        name: '职能设置',
        value: YGFL,
    },  
    {
        name: '工资科目映射',
        value: FYZS,
    },
    {
        name: '云账户科目映射',
        value: FYSX,
    },
]
export default {
    
    data() {
        return {
            selected_tab: tabs_list[0].value,
        }
    },
    mounted() {
        setTimeout(() => {
            this.$refs[this.selected_tab].getListFromParent()
        }, 800)
    },
    render() {
        return <div>
            <VTabs 
                v-model={this.selected_tab}
                on={{change:() => {
                        this.$nextTick(() => {
                            if (!this.$refs[this.selected_tab]) {
                                setTimeout(() => {
                                    this.$refs[this.selected_tab].getListFromParent()
                                }, 800)
                                return 
                            }
                          
                            this.$refs[this.selected_tab].getListFromParent()
                        })
                 }}}
                    background-color="transparent" 
                    color="basil">
                    {tabs_list.map(i => {
                        return <VTab key={i.value} href={`#${i.value}`}>
                            {i.name}
                        </VTab>
                    })}     
        </VTabs>
        <VTabsItems v-model={this.selected_tab}>
              {tabs_list.map(i => {
                  return <VTabItem key={i.value} value={i.value} >
                      
                      <VCard style="margin-top:20px">
                        {i.value === YGFL && <ZNcontain ref={i.value}/>}
                        {i.value === FYZS && <Table enumType={i.value} ref={i.value}/> }
                        {i.value === FYSX && <SxTable ref={i.value}/> }
                      </VCard>
                  </VTabItem>
              })}   
        </VTabsItems>
        </div>
    }
}